import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/home'
import Team from '@/components/team/team'
import SuccessCase from '@/components/news/successCase'
import News from '@/components/news/news'
import NewsDetail from '@/components/news/newsDetail'
import About from '@/components/about/about'
import Join from '@/components/about/join'
import Service from '@/components/service/service'
import Service1 from '@/components/service/service1'
import Service2 from '@/components/service/service2'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '律信网-专业的律师服务平台'     
      }
    },
    {
      path: '/team',
      name: 'team',
      component: Team,
      meta: {
        title: '律信网-专业人员'     
      }
    },
    {
      path: '/successCase',
      name: 'successCase',
      component: SuccessCase,
      meta: {
        title: '律信网-典型案例'     
      }
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        title: '律信网-新闻资讯'     
      }
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: NewsDetail,
      meta: {
        title: '律信网-资讯详情'     
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: '律信网-关于我们'     
      }
    },
    {
      path: '/join',
      name: 'join',
      component: Join,
      meta: {
        title: '律信网-加入人员'     
      }
    },
    {
      path: '/service',
      name: 'service',
      component: Service,
      meta: {
        title: '律信网-业务范围'     
      }
    }
    ,
    {
      path: '/service1',
      name: 'service1',
      component: Service1,
      meta: {
        title: '律信网-诉讼业务'     
      }
    }
    ,
    {
      path: '/service2',
      name: 'service2',
      component: Service2,
      meta: {
        title: '律信网-非诉讼业务'     
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js